import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { Button, CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { InputTextBox } from 'pages/WCPages/SeniorCallScheduler/formFields';
import { goalStyle } from './index.style';
import { useMutation } from 'utilities/react-query';
import { hideApplicationLoader, showApplicationLoader, } from 'common/ApplicationLoader';
import { getCurrentSenior } from 'globals/global.functions';
import { getSeniorFullName, openOverlayDialog, showError, } from 'store/commonReducer/common.action';
import { DIALOG_TYPES } from 'globals/global.constants';
import { useAppDispatch } from 'hooks/reduxHooks';
import { getSleepGoalService, postSleepGoalService, } from 'services/sleepGoalService/sleepGoal.service';
import { Card } from 'common/components/Card';
import { RE_RENDER_GRAPH } from 'pages/WCPages/WellnessDashboard/WellnessDashboard.types';
var SleepGoal = function (_a) {
    var width = _a.width, onGoalGetSuccess = _a.onGoalGetSuccess, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var classes = goalStyle().classes;
    var _c = useState(true), disable = _c[0], setDisable = _c[1];
    var _d = useState(false), callDailySleepApis = _d[0], setCallDailySleepApis = _d[1];
    var _e = useState(80), goal = _e[0], setGoals = _e[1];
    var dispatch = useAppDispatch();
    var fullName = dispatch(getSeniorFullName());
    useEffect(function () {
        getSleepGoal.mutate();
    }, []);
    var onHandleChange = useCallback(function (e) {
        var value = parseInt(e.target.value);
        if (value < 0 || isNaN(value)) {
            setGoals(0);
        }
        else if (value > 100) {
            setGoals(100);
        }
        else {
            setGoals(value);
        }
    }, []);
    var onButtonClick = useCallback(function () {
        if (disabled)
            return;
        if (disable) {
            setDisable(!disable);
        }
        else {
            setCallDailySleepApis(true);
            handleSetSleepGoal(goal);
            setDisable(!disable);
        }
    }, [disable, goal, disabled]);
    var getSleepGoal = useMutation({
        mutationFn: function () {
            dispatch(showApplicationLoader());
            var senior = getCurrentSenior();
            return getSleepGoalService({
                senior_id: senior.seniorID,
                account_id: senior.accountID,
            });
        },
        onSuccess: function (goal) {
            if (callDailySleepApis) {
                onGoalGetSuccess();
            }
            setCallDailySleepApis(false);
            setGoals(goal);
            dispatch(hideApplicationLoader());
        },
        onError: function (error) {
            dispatch(hideApplicationLoader());
            dispatch(showError(error));
        },
    });
    var postSleepGoal = useMutation({
        mutationFn: function (goal) {
            dispatch(showApplicationLoader());
            var senior = getCurrentSenior();
            return postSleepGoalService({
                senior_id: senior.seniorID,
                account_id: senior.accountID,
                sleep_score_goal: goal,
            });
        },
        onSuccess: function () {
            dispatch(hideApplicationLoader());
            getSleepGoal.mutate();
            dispatch(openOverlayDialog({
                type: DIALOG_TYPES.SUCCESS,
                firstMessage: "Sleep Goal is updated successfully for ".concat(fullName, "."),
            }));
            dispatch({ type: RE_RENDER_GRAPH, value: true });
        },
        onError: function (error) {
            dispatch(hideApplicationLoader());
            dispatch(showError(error));
        },
    });
    var handleSetSleepGoal = React.useCallback(function (value) {
        if (disabled)
            return;
        postSleepGoal.mutate(value);
    }, [postSleepGoal, goal, disabled]);
    return (_jsxs(Card, { children: [_jsx(Typography, { component: "div", children: "Set Sleep Goal" }), _jsxs(Box, { style: { display: 'flex', columnGap: '12px' }, children: [_jsx(Box, { children: getSleepGoal.isLoading ? (_jsx(Box, { margin: '0 30px', children: _jsx(CircularProgress, {}) })) : (_jsx(InputTextBox, { required: true, className: classes.input, onChange: onHandleChange, disabled: disable || disabled, inputProps: { value: goal } })) }), _jsx(Button, { className: classes.button, style: { width: '119px' }, variant: 'contained', color: 'primary', size: 'large', "data-testid": 'sleep-goal-button', disabled: disabled, onClick: onButtonClick, children: disable ? 'Edit' : 'Save' })] })] }));
};
export default SleepGoal;
